import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonCopyByChuyenNganhRequest } from "../../../model/request/ke-hoach/IKeHoachMonCopyByChuyenNganhRequest";
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IKeHoachMonSelectSummaryGiaiDoanRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectSummaryGiaiDoanRequest";
import { IKeHoachMonTotalSoKhoi } from "../../../model/respone/ke-hoach/IKeHoachMonTotalSoKhoi";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachMonFullPageActionsObj = {
    CHANGE_FILTER: {} as IKeHoachMonSelectRequest,



    LOAD_START: {} as IKeHoachMonSelectRequest,
    LOAD_SUCCESS: {} as IKeHoachMonViewModel[],
    LOAD_ERRR: "",


    ADDING_MON_SHOW_MODAL: {} as IKeHoachMonSelectRequest,
    ADDING_MON_CLOSE_MODAL: undefined,
    ADDING_MON_CHANGE_SELECTED_IDs: {} as number[],
    ADDING_MONHOC_START: {} as IKeHoachMonAddRequest,
    ADDING_MONHOC_SUCCESS: undefined,
    ADDING_MONHOC_ERRR: "",

    UPDATE_START: {} as IKeHoachMonViewModel[],
    UPDATE_SUCCESS: {} as IKeHoachMonViewModel[],
    UPDATE_ERROR: "",

    LOAD_PHANBOTIET_START: {} as IKeHoachMonSelectSummaryGiaiDoanRequest,
    LOAD_PHANBOTIET_SUCCESS: {} as IKeHoachMonTotalSoKhoi[],
    LOAD_PHANBOTIET_ERRR: "",

    DELETE_START: {} as IIdsRequest,
    DELETE_SUCCESS: {} as IIdsRequest,
    DELETE_ERROR: "",

    COPY_CLIPBOARD_DATA: {} as IKeHoachMonCopyByChuyenNganhRequest,

    PASTE_CLIPBOARD_DATA_START: {} as IKeHoachMonCopyByChuyenNganhRequest,
    PASTE_CLIPBOARD_DATA_SUCCESS: undefined,
    PASTE_CLIPBOARD_DATA_ERROR: "",

    TACH_KHOI_GIANG_START: {} as number,
    TACH_KHOI_GIANG_SUCCESS: undefined,
    TACH_KHOI_GIANG_ERROR: "",

    CHANGE_CAP_NHAT_SO_KHOI_TU_DONG_START: {} as boolean,

};
export const eKeHoachMonFullPageActionIds = generateActionTypeIds(
    eKeHoachMonFullPageActionsObj,
    "KE_HOACH_MON_FULL_PAGE"
);
export type IKeHoachMonFullPageActionTypes = IGenericActionType<
    typeof eKeHoachMonFullPageActionsObj,
    "KE_HOACH_MON_FULL_PAGE"
>;
